import { useActivities } from '../hooks/useActivities.js';
import RunMiniMap from '../components/RunMiniMap.jsx';
import Footer from '../components/Footer.jsx';
import Loading from '../components/Loading.jsx';
import { distanceMiles, pacePerMile, elevationFeet, stravaActivityUrl } from '../lib/format.js';

/** The recent-runs list page (page-recent-runs.php + getRecentRunsPage). */
export default function RecentRunsPage() {
  const { data, loading } = useActivities();

  if (loading) return <Loading />;

  const runs = data.slice(0, 10);

  return (
    <>
      <div className="container-fluid" style={{ padding: 0 }}>
        <div className="row archive-header mob">
          <div className="col-2"></div>
          <div className="col-8 archive-header-text">Recent Runs</div>
          <div className="col-2"></div>
        </div>
        <div className="row archive-body">
          <div className="col-0 col-lg-1"></div>
          <div className="col-12 col-lg-10 archive-content mob">
            {runs.map((run) => (
              <a
                key={run.id}
                href={stravaActivityUrl(run)}
                target="_blank"
                rel="noreferrer"
                className="row archive-row mob border-red"
              >
                <div className="row">
                  <div
                    className="col-3 image-center border-red"
                    style={{ aspectRatio: 1, padding: 0 }}
                  >
                    <RunMiniMap activity={run} className="" style={{ width: '100%', height: '100%' }} />
                  </div>
                  <div className="col-9 rr-content">
                    <div className="row">
                      <div className="col rr-title">{run.name}</div>
                    </div>
                    <div className="row rr-num-content">
                      <div className="col-4 rr-number">
                        <div className="row">
                          <div className="col-12">{pacePerMile(run)}</div>
                        </div>
                        <div className="row">
                          <div className="col-12">/ mi</div>
                        </div>
                      </div>
                      <div className="col-4 rr-number">
                        <div className="row">
                          <div className="col-12">{distanceMiles(run)}</div>
                        </div>
                        <div className="row">
                          <div className="col-12">mi</div>
                        </div>
                      </div>
                      <div className="col-4 rr-number">
                        <div className="row">
                          <div className="col-12">{elevationFeet(run)}</div>
                        </div>
                        <div className="row">
                          <div className="col-12">ft</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
          <div className="col-0 col-lg-1"></div>
        </div>
      </div>
      <Footer />
    </>
  );
}
